import React from "react";

import { WizardContext } from "./Wizard";
import Panel from "../panels/Panel";
import { Side } from "../../types/system/Layout";

export interface WizardStepProps {
    step: number;
    title?: string;

    canPreviousText?: string;
    canProceedText?: string;
    canAbortText?: string;
    frameless?: boolean;
    framed?: boolean;
    hiddenWhenOffscreen?: boolean;

    children?: React.ReactNode;
}

interface WizardStepState {
    step: number;
    show: boolean;
    classes: string;
}

class WizardStep extends React.Component<WizardStepProps, WizardStepState> {
    static contextType = WizardContext;
    context!: React.ContextType<typeof WizardContext>;

    state = {
        show: false,
        step: 0,
    } as WizardStepState;

    componentDidMount(): void {
        this.evalMovement();
    }

    componentDidUpdate(
        _: Readonly<WizardStepProps>,
        prevState: Readonly<WizardStepState>,
    ): void {
        if (
            this.context.step !== this.state.step ||
            prevState.show !== this.state.show
        ) {
            this.evalMovement();
        }
    }

    evalMovement() {
        let classes = "wizard-step buffer";

        if (this.props.framed) classes += " framed";

        if (this.context.step === this.props.step) {
            if (!this.state.show) this.setState({ show: true });
            if (this.context.oldStep < this.props.step)
                classes += " slide-in-right";
            else if (this.context.oldStep > this.props.step)
                classes += " slide-in-left";
        } else if (
            this.state.show &&
            this.context.oldStep === this.props.step
        ) {
            if (this.context.step < this.props.step)
                classes += " slide-out-right";
            else if (this.context.step > this.props.step)
                classes += " slide-out-left";

            setTimeout(() => this.setState({ show: false }), 500);
        }

        this.setState({
            classes: classes,
            step: this.context.step,
        });
    }

    render() {
        return (
            <div className={this.state.classes}>
                {(this.state.show || !this.props.hiddenWhenOffscreen) && (
                    <Panel
                        bufferSide={this.props.frameless ? undefined : Side.All}
                        height="fit-content"
                        minHeight="100%"
                        title={this.props.title}>
                        {this.props.children}
                    </Panel>
                )}
            </div>
        );
    }
}

export default WizardStep;
